export class APIDocument {
  id: string;
  hash: string;
  name: string;
  filename: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: any) {
    this.id = data.id;
    this.hash = data.hash;
    this.name = data.name;
    this.filename = data.filename;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}

export class APITruckDocument extends APIDocument {
  type: 'Insurance' | 'Examination';

  constructor(data: any) {
    super(data.document);
    this.type = data.type;
  }
}

export class APITruck {
  id: string;
  name: string;
  licensePlate: string;
  supplierId: number;
  isActive: boolean;
  insuranceExpiresAt: Date;
  insuranceReminderSentAt: Date;
  examinationExpiresAt: Date;
  examinationReminderSentAt: Date;
  internalNotes: string;
  plannerId: string;
  documents: APITruckDocument[];
  createdAt: Date;
  orders: string[];

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.licensePlate = data.licensePlate;
    this.supplierId = data.supplierId;
    this.isActive = data.isActive;
    this.insuranceExpiresAt = data.insuranceExpiresAt;
    this.insuranceReminderSentAt = data.insuranceReminderSentAt;
    this.examinationExpiresAt = data.examinationExpiresAt;
    this.examinationReminderSentAt = data.examinationReminderSentAt;
    this.internalNotes = data.internalNotes;
    this.plannerId = data.plannerId;
    this.documents = (data.documents || []).map((d: any) => new APITruckDocument(d));
    this.createdAt = data.createdAt;
    this.orders = (data.orders || []).map((o: any) => o.id);
  }
}
